import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { environment } from "../../../environments/environment";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { UserServiceService } from "../../services/user-service/user-service.service";

@Component({
  selector: "app-add-partner",
  templateUrl: "./add-partner.component.html",
  styleUrls: ["./add-partner.component.css"],
})
export class AddPartnerComponent implements OnInit {
  title: string = "Add Partner";
  add_partner: any = {
    name: "",
    email: "",
    phone: "",
    phone_2: "",
    address: "",
    account_number: "",
  };
  partnerId: any;
  isEditState = false;

  current_partner: any;
  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private userService: UserServiceService,
    private fb: FormBuilder,
    private errorHandlerService: ErrorHandlerService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    console.log("Add Partner");
    this.partnerId = +this.route.snapshot.params["id"];
    if (this.partnerId > 0) {
      this.isEditState = true;
      this.title = "Edit Partner";
      this.getPartner(this.partnerId);
    }
  }

  getPartner(id?) {
    this.userService.getPartnersById(id).subscribe(
      (res: any) => {
        if (res.data) {
          this.add_partner.name = res.data.name;
          this.add_partner.email = res.data.email;
          this.add_partner.phone = res.data.phone;
          this.add_partner.phone_2 = res.data.phone_2;
          this.add_partner.address = res.data.address;
          this.add_partner.account_number = res.data.account_number;
        }
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  addPartner() {
    this.slimLoadingBarService.start();
    let serUrl;
    if (this.isEditState) {
      serUrl = this.userService.editPartner(this.partnerId, this.add_partner);
    } else {
      serUrl = this.userService.addPartner(this.add_partner);
    }
    console.log(serUrl);
    serUrl.subscribe(
      (data) => {
        if (this.isEditState) {
          swal("Updated Partner successfully", "", "success");
        } else {
          swal("Added Partner successfully", "", "success");
        }
        this.add_partner = {
          name: "",
          email: "",
          phone: "",
          phone_2: "",
          address: "",
          account_number: "",
        };
        this.router.navigateByUrl("/pages/settings/partners");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/add-partner/add-partner.component.ts